import { Box, CircularProgress, useTheme } from '@mui/material';

export const LoadingFallback = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 9999,
      }}
    >
      <Box
        sx={{
          backgroundColor: theme.palette.background.paper,
          borderRadius: 2,
          padding: 3,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          boxShadow: 3,
        }}
      >
        <CircularProgress size={60} aria-label="Loading content" />
        <Box sx={{ mt: 2, color: theme.palette.text.primary }}>Loading...</Box>
      </Box>
    </Box>
  );
};
